module.exports = __webpack_public_path__ + "img/4.d87a13bb.jpg";